export const HOME__SET_AREA_ID = 'HOME__SET_AREA_ID';

export const HOME__SET_AREA_PICKER_VISIBLE = 'HOME__SET_AREA_PICKER_VISIBLE';
